import Badge from "@components/elements/V2/Badge"
import { Color } from "@constants/V2/color"
import React from "react"

type CategoryBadgeProps = {
  category: string
  className?: string
}

export const getCategoryLabel = (category: string) =>
  category.charAt(0).toUpperCase() + category.slice(1)

const CategoryBadge = ({ category, className }: CategoryBadgeProps) => (
  <Badge
    text={getCategoryLabel(category)}
    style="translucent"
    weight="medium"
    size="subscript-md-fixed"
    textColor={Color.White}
    accentColor={Color.Charcoal}
    uppercaseText={false}
    className={className}
  />
)

export default CategoryBadge
